<template>
  <div>
    <HeaderView></HeaderView>
    <div class="image-container">
      <img
        src="../../public/staticImages/banner(contact).png"
        class="img-fluid h-50"
        alt="Contact Image"
        style="filter: brightness(50%)"
      />
      <div
        class="text-center text-white position-absolute top-50 start-50 translate-middle"
      >
        <h1>CONTACT US</h1>
        <p>Home > Contact Us</p>
      </div>
    </div>
    <div class="container my-5">
      <div class="row">
        <div class="col-md-6">
          <h4>Send Us Message</h4>
          <form @submit.prevent="sendMail()">
            <div class="mb-3">
              <input
                type="text"
                name="name"
                v-model="mailData.name"
                placeholder="Enter Your Name"
                required
                class="form-control rounded-0 p-3"
              />
            </div>
            <div class="mb-3">
              <input
                type="text"
                name="email"
                v-model="mailData.email"
                placeholder="Enter Your Email"
                required
                class="form-control rounded-0 p-3"
              />
            </div>
            <div class="mb-3">
              <input
                type="text"
                name="subject"
                v-model="mailData.subject"
                placeholder="Enter Your Subject"
                required
                class="form-control rounded-0 p-3"
              />
            </div>
            <div class="mb-3">
              <textarea
                name="message"
                v-model="mailData.message"
                rows="5"
                cols="10"
                class="form-control rounded-0 p-3"
                required
                placeholder="Type Message"
              ></textarea>
            </div>

            <button
              type="submit"
              class="btn btn-warning fw-bold fs-5 form-control rounded-0 mb-3 p-2 text-white"
            >
              SEND MESSAGE
            </button>
          </form>
        </div>
        <div class="col-md-6">
          <iframe
            :src="map"
            width="600"
            height="450"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
    <div style="background-color: rgb(15, 184, 196)">
      <div class="container py-5">
        <div class="row">
          <div class="col-md-4 mb-3">
            <div class="row text-white fw-bold">
              <div class="col-2">
                <font-awesome-icon
                  icon="house"
                  class="btn btn-warning text-white rounded-0 py-2"
                />
              </div>
              <div class="col-10">
                No-38/39, Yeywa Hydropower Project Road, 7 Miles, Mandalay -
                Pyin Oo Lwin Road Mandalay, Myanmar, 05085
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="row text-white fw-bold">
              <div class="col-2">
                <font-awesome-icon
                  icon="phone"
                  class="btn btn-warning text-white rounded-0 py-2"
                />
              </div>
              <div class="col-10">Phone : +959 740 899 971</div>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="row text-white fw-bold">
              <div class="col-2">
                <font-awesome-icon
                  icon="envelope"
                  class="btn btn-warning text-white rounded-0 py-2"
                />
              </div>
              <div class="col-10">Email :- info@mdywaterboom.com</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterView></FooterView>
  </div>
</template>

<script>
import FooterView from "./Layouts/FooterView.vue";
import HeaderView from "./Layouts/HeaderView.vue";
import axios from "axios";

export default {
  name: "ContactView",
  components: { HeaderView, FooterView },
  data() {
    return {
      mailData: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      BaseUrl: process.env.VUE_APP_BASE_URL,
      map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3705.4291682459443!2d96.30813207435943!3d21.763645080076003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30cb79d38f5d468f%3A0x9f8ede61fb98223c!2sMandalay%20Waterboom!5e0!3m2!1sen!2smm!4v1726127343277!5m2!1sen!2smm",
    };
  },

  methods: {
    async sendMail() {
      try {
        const response = await axios.post(
          `${this.BaseUrl}/send-mail`,
          this.mailData
        );

        if (response.data.success) {
          alert("Email sent successfully!");
          // Optionally reset the form
          this.mailData = {
            name: "",
            email: "",
            subject: "",
            message: "",
          };
        } else {
          alert("Failed to send the email. Please try again.");
        }
      } catch (error) {
        console.error("Error sending email:", error);
        alert("An error occurred. Please try again later.");
      }
    },
  },

  mounted() {
    document.title = "Contact Us - Mandalay Water Boom";
  },
};
</script>

<style scoped></style>
